<template>
  <div class="app-container">
    <router-view />
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

onMounted(() => {

  console.log('当前路由:', router.currentRoute.value.path)
  // 检查登录状态
  // const token = localStorage.getItem('token');
  // if (!token && router.currentRoute.value.path !== '/login') {
  //   router.push('/login');
  // }
});
</script>

<style scoped>
.app-container {

  /* position: relative;
  display: flex;
  flex-direction: column;
  height: 100vh; */
  /* overflow: auto; */
}
</style>
